import { parseDate } from '../../../config/dayjsConfig'
import { CategorizedExchangeRates, CustomExchangeRate, StatementType } from '../types/exchangeRate'
import { CustomReportDataType } from '../../../redux/context/customReports/typesVariable'

export interface CategorizedRatesWithMeta {
  rates: CategorizedExchangeRates
  meta: {
    totalRates: number
    hasData: boolean
    categories: Array<{
      key: keyof CategorizedExchangeRates
      statementType: StatementType
      dataType: keyof typeof CustomReportDataType
      count: number
      hasData: boolean
    }>
  }
}

// Define the combinations we need to generate
const STATEMENT_TYPES = Object.values(StatementType) as StatementType[]
const DATA_TYPES = Object.values(CustomReportDataType) as Array<keyof typeof CustomReportDataType>

// Utility function: kategorisoi exchange ratet
export const categorizeExchangeRates = (rates: CustomExchangeRate[] = []): CategorizedExchangeRates => {
  const categorized = {} as CategorizedExchangeRates

  STATEMENT_TYPES.forEach(statementType => {
    DATA_TYPES.forEach(dataType => {
      const key = `${statementType}-${dataType}` as keyof CategorizedExchangeRates
      categorized[key] = rates
        .filter(rate => rate.statementType === statementType && rate.dataType === CustomReportDataType[dataType])
        .filter(rate => rate.month != null && rate.year != null)
        .reduce((acc, curr) => {
          // Format as M/Y (single digit month/year) with timezone handling
          const date = parseDate(curr.date)
          const indexKey = date?.format('MM/YYYY') || ''
          acc[indexKey] = curr
          return acc
        }, {} as { [key: string]: CustomExchangeRate })
    })
  })

  return categorized
}
